import React, {useRef, useState } from 'react';
import './contactUs.css';
import Menubar from '../home/menubar/Menubar';
import Address from '../home/footer/Address';
import ScrollToTopProgress from '../home/header/ScrollToTopProgress';
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { TbMapPinCode } from "react-icons/tb";
import { TbPhoneRinging } from "react-icons/tb";
import { MdOutgoingMail } from "react-icons/md";
import { TbBrandOffice } from "react-icons/tb";
import { FaWindowClose } from "react-icons/fa";
import Header from '../home/header/Header';
import { contact } from '../home/data.js';

const ContactUs = () => {

  const {contact_img_url} = contact

  //model
  const [loading, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  //loading

  const formRef = useRef(null);

  const isValidZip = (zip) => /^\d{6}$/.test(zip);
  const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  const userName = (event)=>{
        if(!/^[a-zA-Z ]$/.test(event.key) && event.key.length === 1){
          event.preventDefault();
        }
      }
  const emailValidation = (event)=>{
        if(!/^[a-zA-Z0-9@._-]$/.test(event.key) && event.key.length === 1){
          event.preventDefault();
        }
      }
  const numberValidation = (e) => {
        if (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
              e.preventDefault();
            }
      }
  const handleReset = () => {
    setFormData({
      fname: '',
      lname: '',
      email: '',
      address: '',
      state: '',
      zip: '',
      phone: '',
      message: '',
    });
    formRef.current.classList.remove('was-validated');
  };
  const [formData, setFormData] = useState({
     fname:'',
     lname:'',
     email:'',
     address:'',
     state:'',
     zip:'',
     phone:'',
     message:''
    });//

  const handleChange = (e) => {
    const { name, value } = e.target;
    if ((name === 'zip' || name === 'phone') && !/^\d*$/.test(value)) {
    return;
  }
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  const handleSubmit = async (event) => {  //async
    const form = formRef.current;
    event.preventDefault();
    // event.stopPropagation();

    if(!form.checkValidity()){
      form.classList.add('was-validated');
      return;
    }
    setLoading(true)
    try{
    // const res = await fetch("http://localhost:5000/send/contact-us",{
    const res = await fetch("https://api-express-node-bd0o.onrender.com/send/contact-us",{
      method:"POST",
      headers:{"Content-Type": "application/json"},
      body: JSON.stringify(formData),
    });
    const result = await res.json();
    setModalMessage(result.success? "Thanks for reaching out! We'll respond shortly." : "Oops! Something went wrong. Please try again later.");
    setShowModal(true);
    handleReset();
  }
  catch(error){
    console.log("Error sending email:", error);
    // alert("Something went wrong. Please try again later.")
    setModalMessage("Something went wrong. Please try again later.");
    setShowModal(true);
  }
  finally{
    setLoading(false)
  }
  };

  return (
    <div>
      <Header/>
      <Menubar/>
	
  <div className='contact-img'>
            <img src={contact_img_url} style={{width: '100%'}} alt="Contact-US" />
          </div>
	<section className='contact'>
		<div className="">
			<h1 style={{borderBottomStyle: 'groove'}}>Contact Us</h1>
		</div>
	</section>

	  <div className="container">
		 <div className="row">
                <div className="container mt-4 col-md-5 col-sm-10 contrainer-left">
					<div className="content">
						<p><b className='content-title'><span className='address-icon'><HiOutlineOfficeBuilding /></span>Head Office :</b></p>
						<p>2-62, Adarsh Computers, Near Ravindra Bharathi School, Main Road, Kondapalli, Vijayawada</p>
						<p><b className='content-title'><span className='address-icon'><TbMapPinCode/></span>Pin :</b>521228</p>
						<p><b className='content-title'><span className='address-icon'><TbPhoneRinging/></span>Mobile No :</b>+91 9494760846, +91 8019812384</p>
						<p><b className='content-title'><span className='address-icon'><MdOutgoingMail/></span>E-Mail :</b> chandu842@gmail.com</p>
						<p><b className='content-title'><span className='address-icon'><TbBrandOffice/></span>Office : Kondapalli,Vijawada,AP.. (India)</b></p>
                	</div>
                </div>


      <div className="container mt-4 col-md-6 col-sm-10 contrainer-right">
        <form
          className="row g-3 needs-validation"
          noValidate
          ref={formRef}
          onSubmit={handleSubmit}
        >
          <div className="col-md-4">
            <label htmlFor="validationCustom01" className="form-label">First Name</label>
            <input name='fname' type="text" className="form-control" id="validationCustom01" placeholder='Name' autoComplete='off' required 
            onKeyDown={userName} onChange={handleChange} maxLength={30} value={formData.fname}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustom02" className="form-label">Last Name</label>
            <input type="text" name='lname' className="form-control" id="validationCustom02" placeholder='Surname' autoComplete='off' required 
            onKeyDown={userName} onChange={handleChange} maxLength={30} value={formData.lname}/>
            <div className="invalid-feedback">In Validated!</div>
          </div>

          <div className="col-md-4">
            <label htmlFor="validationCustomUsername" className="form-label">Email Id</label>
            <div className="input-group has-validation">
              <span className="input-group-text" id="inputGroupPrepend">@</span>
              <input
                type="email"
                className="form-control"
                id="validationCustomUsername"
                aria-describedby="inputGroupPrepend"
				        autoComplete='off'
                required
                onKeyDown={emailValidation}
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <div className="invalid-feedback">Please provide a valid Mail.</div>
			  <div className="invalid-feedback">In Validated!</div>
            </div>
          </div>

          <div className="col-md-5">
            <label htmlFor="validationCustom03" className="form-label">Address</label>
            <input type="text" className="form-control" id="validationCustom03" autoComplete='off' required maxLength={50} name='address' value={formData.address} onChange={handleChange}/>
            <div className="invalid-feedback">Please provide a valid Address.</div>
          </div>

          <div className="col-md-5">
            <label htmlFor="validationCustom04" className="form-label">State</label>
            <select className="form-select" id="validationCustom04" required name='state' value={formData.state} onChange={handleChange}>
              <option value="">Select</option>
              <option value="AP">Andhra Pradesh</option>
              <option value="TS">Telangana</option>
            </select>
            <div className="invalid-feedback">Please select a valid state.</div>
          </div>

          <div className="col-md-5">
            <label htmlFor="validationCustom05" className="form-label">Zip</label>
            <input type="text" name='zip' inputMode='numeric' maxLength={6} minLength={6} className={`form-control ${formData.zip && !isValidZip(formData.zip) ? 'is-invalid' : ''}`} id="validationCustom05 zip" required 
          value={formData.zip}
          onChange={handleChange}
          onKeyDown={numberValidation}
          autoComplete='off'
          />
            <div className="invalid-feedback">Please provide a valid zip.</div>
          </div>

          <div className="col-md-5">
            <label htmlFor="validationCustom05" className="form-label">Contact No</label>
            <input
              name='phone'
              type="text"
              inputMode="numeric"
              maxLength={10}
              minLength={10}
              className={`form-control ${formData.phone && !isValidPhone(formData.phone) ? 'is-invalid' : ''}`}
              id="validationCustom05 phone"
              required
              value={formData.phone}
              onChange={handleChange}
              onKeyDown={numberValidation}
              autoComplete='off'
            />

            <div className="invalid-feedback">Please provide a valid phone no.</div>
          </div>
		  


		    <div className="mb-3">
    <label htmlFor="validationTextarea" className="form-label">Queries</label>
    <textarea 
    name='message' onChange={handleChange} value={formData.message}
     className="form-control" id="validationTextarea" placeholder="Please enter required courses or any related queries." autoComplete='off' required></textarea>
    <div className="invalid-feedback">
      Please enter required courses or any related queries.
    </div>
  </div>

          <div className="col-12">
            <button className="btn btn-primary" type="submit">Submit</button>&emsp;&emsp;
            <button className="btn btn-danger" type="reset"  onClick={handleReset}>Reset</button>
          </div>
        </form>
      </div>

      </div>
      </div>

	  <div>
		<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61178.11254297552!2d80.53115042705674!3d16.595019414381795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35ebe322aa5ccb%3A0xabe38ca7549d3b3b!2sAadarsh%20Malti%20Skills!5e0!3m2!1sen!2sin!4v1644262770317!5m2!1sen!2sin" className='map' allowFullScreen loading="lazy" title="Aadarsh Malti Skills Location Map"></iframe>
	</div>

      <Address />
	  <ScrollToTopProgress/>

    
{/* Loading Spinner */}
{loading && (
  <div className="loading-overlay">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
)}

{/* Modal Popup */}
{showModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      <div><button className='close-btn' onClick={() => setShowModal(false)}><FaWindowClose/></button></div>
      <p className='modal-msg'>{modalMessage}</p>
      <button className="btn btn-primary" onClick={() => setShowModal(false)}>Close</button>
    </div>
  </div>
)}

    </div>
  );
};



export default ContactUs;
